import Client from '../client'
// import {questionsWithAnswer, stages} from '../db/testdb'

const stageStore = {
    namespaced: true,
    state: {
        stages: [],
        questionsWithAnswer: {},
        scholarship: null,
        // application: null
    },
    actions: {
        async fetchStages({commit, state, dispatch}, {appId}) {
            try {
                if(!state.scholarship || !state.scholarship['Scholarship_Application__c.Id'] || state.scholarship['Scholarship_Application__c.Id'] != appId) {
                    dispatch('fetchScholarship', {appId})
                }
                const client = Client();
                const res = await client.get(`/stages?applicationId=${appId}`)
                if(res.status === 200) {
                    commit('updateData', {key: 'stages', payload: res.data});
                }
            } catch(e) {
                console.log(e);
            }
        },
        async fetchQuestionsWithAnswer({commit, state, dispatch}, {stageId, appId}) {
            try {
                if(state.stages.length === 0) {
                    await dispatch('fetchStages', {appId});
                }
                const stage = state.stages.find(s => s.Id === stageId);
                let res;
                const client = Client();
                switch(stage.Category__c && stage.Category__c.toLowerCase()) {
                    case 'referee':
                        res = await client.get(`/references/referees?applicationId=${appId}`)
                        if(res.status === 200) {
                            commit('updateForOneStage', {stageId, payload: res.data});
                        }
                        break;
                    case 'interview':
                        res = await client.get(`/applications/${appId}/stages/${stageId}`)
                        if(res.status === 200) {
                            commit('updateForOneStage', {stageId, payload: res.data});
                        }
                        break;
                    default:
                        res = await client.get(`/applications/${appId}/stages/${stageId}`)
                        if(res.status === 200) {
                            commit('updateForOneStage', {stageId, payload: res.data});
                        }
                }
            } catch(e) {
                console.log(e);
            }
        },
        async fetchScholarship({commit}, {appId}) {
            try {
                const client = Client();
                const res = await client.get(`/scholarships?applicationId=${appId}`)
                if(res.status === 200) {
                    commit('updateData', {key: 'scholarship', payload: res.data});
                }
            } catch(e) {
                console.log(e);
            }
        },
        // async fetchApp({commit, rootGetters}, {appId}) {
        //     try {
        //         const res = await fetchData(`/api/applications/${appId}`, rootGetters['user/token'])
        //         if(res.status === 200) {
        //             commit('updateScholarshipAndApplication', {payload: res.data});
        //         }
        //     } catch(e) {
        //         console.log(e);
        //     }
        // },
    },
    mutations: {
        updateData(state, {key, payload}) {
            state[key] = payload;
        },
        updateForOneStage(state, {stageId, payload}) {
            state.questionsWithAnswer = {
                ...state.questionsWithAnswer,
                [stageId]: payload
            };
        },
        updateAnswer(state, {stageId, questionId, answer, answerId}) {
            const questions = [...state.questionsWithAnswer[stageId]];
            const index = questions.findIndex(q => q.Id === questionId);
            if(index === -1) return;
            questions[index] = {
                ...questions[index],
                'Answer__c.Answer__c': answer,
                'Answer__c.Id': answerId ? answerId : questions[index]['Answer__c.Id'],
            }
            state.questionsWithAnswer = {
                ...state.questionsWithAnswer,
                [stageId]: questions
            };
        },
        updateAnswerIds(state, {stageId, data}) {
            const questions = [...state.questionsWithAnswer[stageId]];
            const newQuestions = questions.map(q => {
                const newAnswer = data.find(d => d.qid === q.Id);
                if(newAnswer) {
                    return {
                        ...q,
                        'Answer__c.Id': newAnswer.aid ? newAnswer.aid : q['Answer__c.Id'],
                    }
                }
                return {...q}
            })
            state.questionsWithAnswer = {
                ...state.questionsWithAnswer,
                [stageId]: newQuestions
            };
        },
        updateReferee(state, {stageId, type, prop, value}) {
            const questions = [...state.questionsWithAnswer[stageId]];
            let question = questions.find(q => q['Type__c'] === type);
            if(!question) {
                question = {Type__c: type};
                questions.push(question);
            }
            question[prop] = value;
            state.questionsWithAnswer = {
                ...state.questionsWithAnswer,
                [stageId]: questions
            };
        },
        updateStageStatus(state, {stageId, status}) {
            const stages = [...state.stages];
            const index = stages.findIndex(s => s.Id === stageId);
            stages[index] = {
                ...stages[index],
                Status__c: status,
            }
            state.stages = stages;
        }
        // updateScholarshipAndApplication(state, {payload}) {
        //     state.application = {
        //         Id: payload.id,
        //         status: payload.status
        //     };
        //     state.scholarship = {Id: payload.scholarship_id};
        // }
    },
    getters: {
        stages: state => {
            return state.stages;
        },
        questionsWithAnswer: state => state.questionsWithAnswer,
        scholarship: state => state.scholarship,
        // application: state => state.application,
    }
}

// function fetchData(url, token, commit) {
//     axios.interceptors.response.use(function (response) {
//         return response;
//       }, function (error) {
//         if(error.response.status == 401) {
//             commit('user/updateUser', {token: null});
//             const redirectionUrl = process.env.VUE_APP_SALESFORCE_REDIRECT_URL.replace('{{HOST}}', window.location.host);
//             window.location.href = redirectionUrl;
//         }
//         return Promise.reject(error);
//       });
//     return axios.get( url,
//         {
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': token
//             }
//         }
//     )
// }

export default stageStore;
